import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { WOOSMAP_LOADER, WOOSMAP_KEY } from '~/const/3rd';
import unavailableHeavyProducts from '~/const/patch';

var StoreAvailabilityModal = () => import(
/* webpackMode: "eager" */
'~/components/molecules/Product/Modal/StoreAvailabilityModal.vue');

export default {
  name: 'StoreAvailability',
  components: {
    StoreAvailabilityModal
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    isSimpleLink: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showModal: false,
      modal: null,
      loaded: false
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    unavailableProducts() {
      return unavailableHeavyProducts(this.product.reference, this.locale.iso) ? 'unavailable' : 'availability';
    }

  }),
  methods: {
    closeAction() {
      this.showModal = false;
      this.modal = null;
    },

    handleClick(event) {
      var _this = this;

      if (!this.loaded) {
        this.asyncScript(WOOSMAP_LOADER).then( /*#__PURE__*/_asyncToGenerator(function* () {
          var loaderOptions = {
            version: '1.4',
            publicKey: WOOSMAP_KEY
          };
          window.WoosmapLoader.load(loaderOptions);
          _this.loaded = true;
        })).catch(err => {
          this.$logger.error(err);
        });
      }

      this.modal = 'store-availability-modal';
      this.showModal = true;
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_Dispo_mag',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    }

  }
};